import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import ErrorBoundary from "../../../error/ErrorBoundary/ErrorBoundary";

const RaiseIssueInvoiceComponent = lazy(
  () => import("../components/RaiseIssueInvoice")
);

const RaiseIssueInvoice: RouteObject = {
  path: "/invoice/report",
  element: <RaiseIssueInvoiceComponent />,
  errorElement: <ErrorBoundary />,
};

export default RaiseIssueInvoice;
